module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/001-mauritius-ac161988b4ead1fe082ab9006b2733cb.svg";